import { render, staticRenderFns } from "./Ub04.vue?vue&type=template&id=ba6ed7b4&scoped=true"
import script from "./Ub04.vue?vue&type=script&lang=js"
export * from "./Ub04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6ed7b4",
  null
  
)

export default component.exports